module.exports = __webpack_public_path__ + "static/media/card-empty.b5c9fde2.png";